module.exports = __webpack_public_path__ + "img/question.cdfd87ae.svg";